<!-- 押箱 -->
 <template>
    <div>
       <el-form :inline="true" class="demo-form-inline" label-width="75px" size="mini">
            <el-form-item label="提单号" prop="mblNo">
                <el-input  clearable v-model="seacherForm.mblNo"></el-input>
            </el-form-item>
            <el-form-item label="供应商" prop="supply" >
                <el-select v-model="seacherForm.supply" clearable filterable  placeholder="请选择供应商">
                    <el-option v-for="item in companyNameList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status" >
                 <el-select v-model="seacherForm.status" clearable filterable  placeholder="请选择状态">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" plain @click="applyBoxList">查询</el-button>
                <el-button type="success" plain @click="addFee">新增</el-button>
            </el-form-item>
        </el-form>
        <!-- 申请列表 -->
        <el-table :data="containerFeeList" style="width: 100%;height: calc(100vh - 180px);" height="100%" :header-cell-style="{'text-align':'center'}"
            :summary-method="getSummaries" :show-summary="containerFeeList.length === 0 ? false: true" border  >
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column  prop="blNo" label="提单号" align="center" > </el-table-column>
            <el-table-column  prop="containerInfo" label="箱型量" align="center"> </el-table-column>
            <el-table-column  prop="supply" label="船公司" align="center"> </el-table-column>
            <el-table-column  prop="total" label="押箱金额"  align="right"> 
                <template slot-scope="scope">
                    <span v-format="'#,##0.00'">{{ scope.row.total }}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="payStatus" label="付款状态" align="center"> </el-table-column>
            <el-table-column  prop="fkBillNo" label="付款单号" align="center"> </el-table-column>
            <el-table-column  prop="status" label="押箱状态" align="center"> 
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status=='使用中'" type="danger">使用中</el-tag>
                    <el-tag v-if="scope.row.status=='申请退押'" type="warning">申请退押</el-tag>
                    <el-tag v-if="scope.row.status=='已退押'" type="success">已退押</el-tag>
                </template>
            </el-table-column>
            <el-table-column  prop="createMan" label="押箱人" width="80" align="center"> </el-table-column>
            <el-table-column  prop="createTime" label="押箱时间" width="135" align="center"> </el-table-column>
            <el-table-column  prop="applyTime" label="申请退押时间" align="center" width="135"> </el-table-column>
            <el-table-column  prop="backMan" label="回款登记人" align="center"> </el-table-column>
            <el-table-column  prop="backTime" label="回款登记时间" align="center" width="135"> </el-table-column>
            <el-table-column  prop="freeDays" label="免费箱使" width="80" align="right"> </el-table-column>
            <el-table-column   label="操作" width="100" align="center"> 
                <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.payStatus === '未付款'" size="mini" @click="paymentApply(scope.row)">付款</el-button>
                    <el-button type="text" v-if="scope.row.status === '使用中' && scope.row.payStatus === '已付款'" size="mini" @click="depositMoney(scope.row)">申请退押</el-button>
                    <el-button type="text" v-if="scope.row.status === '申请退押'" size="mini" @click="PayCollection(scope.row)">回款</el-button>
                </template>
            </el-table-column>
    </el-table>
    <!-- 分页 -->
     <div  style="background-color: white;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="seacherForm.pageNum" :page-sizes="[10, 50, 100]" :page-size="seacherForm.pageSize" style="padding: 10px;"
            layout="sizes, prev, pager, next" :total="seacherForm.total">
        </el-pagination>
    </div>
        <!-- 新增押箱弹窗 -->
         <el-dialog title="新增押箱登记" :visible.sync="containerFeeCode" width="62%" :before-close="handleCloseFee" :close-on-click-modal="false"	>
            <el-form :inline="true" class="demo-form-inline" label-width="80px" size="mini"  ref="containerFeeForm" :model="containerFeeForm"
            :rules="containerFeeRules">
                <el-form-item label="提单号" prop="blNo">
                    <el-input clearable v-model="containerFeeForm.blNo" @keyup.enter.native="getContainersBy"></el-input>
                </el-form-item>
                <el-form-item label="箱型箱量" prop="containerInfo">
                    <el-input clearable v-model="containerFeeForm.containerInfo" ></el-input>
                </el-form-item>
                <el-form-item label="船公司" prop="supply">
                    <el-select v-model="containerFeeForm.supply" placeholder="请选择" filterable>
                        <el-option v-for="item in supplyList" :key="item.id" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="押箱金额" prop="total">
                    <el-input clearable v-model="containerFeeForm.total" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" ></el-input>
                </el-form-item>
                <el-form-item label="箱使" prop="freeDays">
                    <el-input clearable v-model="containerFeeForm.freeDays" onkeyup="value=value.replace(/[^\d]/g, '')" ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <el-input clearable type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="containerFeeForm.note" style="width:760px" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseFee">取 消</el-button>
                <el-button type="primary" @click="sureAddFee('containerFeeForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 付款申请弹窗 -->
         <el-dialog title="付款申请" :visible.sync="paymentApplyCode" width="62%" :before-close="handleClosePay">
            <el-form :inline="true" class="demo-form-inline" label-width="80px" size="mini"  ref="feeVoucher" :model="feeVoucher">
                <el-form-item label="单据编号" prop="billNo">
                    <el-input :disabled="true" v-model="feeVoucher.billNo" ></el-input>
                </el-form-item>
                <el-form-item label="往来单位" prop="company">
                    <el-input :disabled="true" v-model="feeVoucher.company" ></el-input>
                </el-form-item>
                <el-form-item label="币制" prop="currency">
                    <el-input :disabled="true" v-model="feeVoucher.currency" ></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="amount">
                    <el-input :disabled="true" v-model="feeVoucher.amount" ></el-input>
                </el-form-item>
                <el-form-item label="开票信息" prop="invoiceInfo">
                    <el-input :disabled="true" type="textarea" :rows="6" v-model="feeVoucher.invoiceInfo"  style="width:445px" ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note" >
                    <el-input type="textarea" :rows="6" v-model="feeVoucher.note" style="width:445px" ></el-input>
                </el-form-item>
            </el-form>
            <el-table :data="feeRecordList" style="width: 100%">
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column prop="feeName" label="费用名称" > </el-table-column>
                <el-table-column prop="company" label="往来单位" > </el-table-column>
                <el-table-column prop="totalWt" label="结算金额"  > 
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'" >{{ scope.row.totalWt }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClosePay">取 消</el-button>
                <el-button type="primary" @click="surePaymentApply">确 定</el-button>
            </span>
        </el-dialog>
</div>
</template>
<script>
import req from '@/utils/index.js'
import url1 from '@/config/url2.js'
export default {
    data() {
        return {
            statusList:[ // 状态列表
                {value:'使用中',label:'使用中'},
                {value:'申请退押',label:'申请退押'},
                {value:'已退押',label:'已退押'},
            ],
            containerFeeList:[], // 申请列表
            seacherForm:{
                mblNo:'',
                supply:'',
                status:'',
                pageNum:1,
                pageSize:10,
                total:0,
            }, // 搜索条件
            containerFeeCode:false, // 新增押箱弹窗显示
            containerFeeForm:{
                blNo:'',
                containerInfo:'',
                total:0,
                note:'',
                freeDays:0,
                supply:'',
            }, // 新增押箱表单
            supplyList:[],// 船公司列表
            companyNameList:[], // 往来单位列表
            // 付款申请弹窗
            paymentApplyCode:false,
            feeVoucher:{}, // 押箱表单
            feeRecordList:[], // 费用列表
            containerFeeRules:{
                blNo:[
                    { required: true, message: '请输入提单号', trigger: 'blur' }
                ],
                supply:[
                    { required: true, message: '请选择船公司', trigger: 'blur' }
                ],
                total:[
                    { required: true, message: '请输入押箱金额', trigger: 'blur' },
                    { 
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,  // 匹配非零数字（支持小数） ^(?!0+(\.0+)?$)：逆向否定预查，排除纯 0（包括 0.0、0.00 等格式）
                        message: '押箱金额不能为0', 
                        trigger: ['blur', 'change']
                    }
                ],
                freeDays:[
                    { required: true, message: '请输入箱使', trigger: 'blur' },
                    { 
                        pattern: /^(?!0+(\.0+)?$)\d+(\.\d+)?$/,  // 匹配非零数字（支持小数） ^(?!0+(\.0+)?$)：逆向否定预查，排除纯 0（包括 0.0、0.00 等格式）
                        message: '箱使不能为0', 
                        trigger: ['blur', 'change']
                    }
                ],
            },
            
        }
    },
     mounted() {
        this.applyBoxList()
        this.getsupplyList()
        this.getcompanyName()
    },
    methods: {
        // 查询往来单位
        getcompanyName() {
            let URL = `${url1.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.companyNameList = res.data.data
                }
            })
        },
        // 页数发生改变时
        handleCurrentChange(val) {
            this.seacherForm.pageNum = val;
            this.applyBoxList();
        },
        handleSizeChange(val) {
            this.seacherForm.pageSize = val
            this.applyBoxList()
        },
        // 查询押箱列表
        applyBoxList(){
            let URL = `${url1.applyBoxList}/${this.seacherForm.pageNum}/${this.seacherForm.pageSize}?mblNo=${this.seacherForm.mblNo}&supply=${this.seacherForm.supply}&status=${this.seacherForm.status}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.containerFeeList = res.data.data.records;
                    this.seacherForm.pageNum = res.data.data.current
                    this.seacherForm.pageSize = res.data.data.size
                    this.seacherForm.total = res.data.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 新增押箱申请
        addFee(){
            this.containerFeeCode = true
        },
        // getContainersBy
        // 关闭弹窗
        handleCloseFee(){
            this.$refs.containerFeeForm.resetFields();
            this.containerFeeCode = false   
        },
        // 根据提单号查询集装箱
        getContainersBy(){
            let URL = `${url1.getContainersBy}/${this.containerFeeForm.blNo}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.containerFeeForm.containerInfo = res.data.data;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 查询船公司
        getsupplyList() { 
            let URL = `${url1.getSupplyByName}`;
            req.get(URL,this.containerFeeForm).then(res => {
                if (res.data.code === 200) {
                    this.supplyList = res.data.data;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 创建费用
        sureAddFee(formName){
             this.$refs[formName].validate((valid) => {
                if (valid) {
                    let URL = `${url1.createBoxFee}`;
                    req.post(URL,this.containerFeeForm).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: res.data.message
                            });        
                            this.handleCloseFee()                    
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            });
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 付款申请
        paymentApply(data){
            this.paymentApplyCode = true
            let URL = `${url1.applyBoxFee}/${data.id}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.feeRecordList = res.data.data.feeRecordList                   
                    this.feeVoucher = res.data.data.feeVoucher                   
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        // 确认申请
        surePaymentApply(){
            // saveBoxFeeApply
            const params = {
                feeVoucher:this.feeVoucher, 
                feeRecordList:this.feeRecordList
            }
            let URL = `${url1.saveBoxFeeApply}`;
            req.post(URL,params).then(res => {
                if (res.data.code === 200) {
                    this.paymentApplyCode = false
                    this.applyBoxList()
                    this.$message({
                        message: '申请成功，请去付费申请界面中发起审批流程',
                        type: 'success'
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
            
        },
        // 关闭付款时申请
        handleClosePay(){
            this.paymentApplyCode = false
        },
        // 申请退押
        depositMoney(data){
            this.$confirm('是否确认申请退押?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url1.applyBackFee}/${data.id}`;
                req.put(URL).then(res => {
                    if (res.data.code === 200) {
                        this.applyBoxList()
                        this.$message({
                            message: '申请退押成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                })
            }).catch(() => {
                          
            });
        },
        // 回款
        PayCollection(data){
            // 判断是否是财务身份
            if(localStorage.getItem('role') === '财务'){
                this.$confirm('是否确认申请回款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let URL = `${url1.confirmBackFee}/${data.id}`;
                    req.put(URL).then(res => {
                        if (res.data.code === 200) {
                            this.applyBoxList()
                            this.$message({
                                message: '回款成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            });
                        }
                    })
                }).catch(() => { })
            }else{
                this.$message.error({
                    message: '非财务人员不可回款'
                });
            }
        },
        // 表格合计
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    // 第一列显示"合计"文本
                    sums[index] = '合计';
                    return;
                }
                // 只计算金额列(prop为'amount')
                if (column.property === 'total') {
                    const values = data.map(item => Number(item[column.property]));
                    // 排除非数值
                    const validValues = values.filter(value => !isNaN(value));
                    if (validValues.length > 0) {
                        sums[index] = validValues.reduce((prev, curr) => {
                            return prev + curr;
                        }, 0);
                            // 添加单位（可选）
                        sums[index] = Number(sums[index]).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        } else {
                            sums[index] = ' ';
                        }
                    } else {
                        // 其他列留空
                        sums[index] = '';
                    }
            });
            return sums;
        },
    },
}

</script>
<style lang="css" scoped>
::v-deep .el-table{
    margin-top: 0px;
}
::v-deep .el-pagination{
    margin-top: 0px;
}
</style>